import '@hotwired/turbo-rails';

Turbo.session.drive = false;

// Disable Turbo Prefetch (https://turbo.hotwired.dev/handbook/drive#prefetching-links-on-hover)
const meta = document.createElement('meta');
meta.setAttribute('name', 'turbo-prefetch');
meta.setAttribute('content', 'false');
document.head.appendChild(meta);

$(document).on('turbo:frame-render', (e) => {
  $(document).trigger('dom-update', e.target);
});

$(document).on('turbo:load', () => {
  $(document).trigger('dom-update');
});
